import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AUTH_ENABLED } from '../../shared/infra/auth/AuthConfig';
import { handleLogout } from '../login/logout';
import EditorNavigationMenu from './EditorNavigationMenu';
import OpenBookIcon from '../../shared/components/icons/OpenBookIcon';
import MenuIcon from '../../shared/components/icons/MenuIcon';
import CloseIcon from '../../shared/components/icons/CloseIcon';

const DefaultNavigationMenu = ({ currentPage }) => {
  const { pathname } = useLocation();
  const isCoursePage = ['/', '/courses', '/lecture'].includes(pathname) || pathname.startsWith('/course/');
  return (
    <>
      <li><Link to="/home" aria-current={currentPage('/home')}>Home</Link></li>
      <li><Link to="/courses" aria-current={isCoursePage ? 'page' : undefined}>Courses</Link></li>
      <li><Link to="/contact" aria-current={currentPage('/contact')}>Contact</Link></li>
    </>
  );
};

const NavigationMenu = ({ isAuthenticated = AUTH_ENABLED }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isEditorMode = pathname === "/editor" || pathname.startsWith("/editor/")
    || pathname === '/drafts' || pathname === '/draft';
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const currentPage = (...paths) => paths.includes(pathname) ? 'page' : undefined;

  useEffect(() => {
    setIsMenuOpen(false);
  }, [pathname]);

  return (
    <nav className={`navigation ${isEditorMode ? 'navigation--editor' : ''}`} aria-label="Main navigation">
      <Link className="navigation__brand" to={isEditorMode ? "/editor" : "/home"} aria-label="Openlexia home">
        <OpenBookIcon />
        <span>Openlexia</span>
      </Link>
      <button className="navigation__toggle" type="button" aria-label={isMenuOpen ? 'Close main menu' : 'Open main menu'} aria-expanded={isMenuOpen} aria-controls="main-menu" onClick={() => setIsMenuOpen(!isMenuOpen)}>
        {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
      </button>
      <ul id="main-menu" className={`menu ${isMenuOpen ? 'is-open' : ''}`}>
        {isEditorMode ? <EditorNavigationMenu currentPage={currentPage} /> : <DefaultNavigationMenu currentPage={currentPage} />}
        {isAuthenticated && <li className="logout-item">
          <Link to="/" onClick={handleLogout}>Logout</Link>
        </li>}
      </ul>
      <label className="navigation__mode-switch">
        <input type="checkbox" role="switch" checked={isEditorMode} onChange={event => navigate(event.target.checked ? '/editor' : '/')} />
        <span className="navigation__switch-track" aria-hidden="true" />
        <span>Switch to editor mode</span>
      </label>
    </nav>
  );
};

export default NavigationMenu;
